export default __webpack_public_path__ + "static/media/flow.9186c740.jpeg";